import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'
import {SearchBatchesInput} from '@cypro/engine/queries'

export function useSearchBatches(args: SearchBatchesInput) {
  return useQuery(queries.stocks.searchBatches(args))
}
